import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import useColors from "../../../api/hooks/useColors";

const HeatmapTooltip = ({ cell }) => {
  const colors = useColors();

  const extractCellData = useMemo(() => {
    if (!cell)
      return {
        severity: "N/A",
        entityType: "",
        category: "",
        cellColor: colors.grey_300,
      };

    const severity = cell?.data?.y;
    const entityType = cell?.data?.x ?? "";
    const category = cell?.serieId ?? cell?.data?.id ?? "";
    const cellColor = cell?.color ?? colors.grey_300;

    return { severity, entityType, category, cellColor };
  }, [cell]);

  const { severity, entityType, category, cellColor } = extractCellData;

  if (severity === 0) {
    return (
      <Box
        sx={{
          width: "100%",
          padding: "8px",
        }}
      >
        <Typography variant="caption">
          The Security Practice is not applicable.
        </Typography>
      </Box>
    );
  }
  return (
    <Box
      sx={{
        width: "100%",
        padding: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: "12px",
          height: "12px",
          backgroundColor: cellColor,
        }}
      />
      <Typography variant="caption">
        {entityType} - {category}
      </Typography>
    </Box>
  );
};

export default HeatmapTooltip;
